import { useUnsafeMemo } from 'modules/core/hooks/useMemo'

import { CostCenterConfigurations } from 'modules/cost_centers/lib/types'

export interface JobCatalogColumnsVisibility {
  family: boolean
  function: boolean
  role: boolean
}

export const useJobCatalogColumns = (
  configurations: CostCenterConfigurations
): JobCatalogColumnsVisibility => {
  const jobCatalogStructure = useUnsafeMemo(() => {
    const jcConfig = configurations.find((config) => config.structure.startsWith('job_catalog_'))
    return jcConfig?.structure
  }, [configurations])

  const shouldShowJobCatalogColumns = useUnsafeMemo(() => {
    return {
      family:
        jobCatalogStructure === 'job_catalog_family' ||
        jobCatalogStructure === 'job_catalog_function' ||
        jobCatalogStructure === 'job_catalog_role',
      function:
        jobCatalogStructure === 'job_catalog_function' ||
        jobCatalogStructure === 'job_catalog_role',
      role: jobCatalogStructure === 'job_catalog_role',
    }
  }, [jobCatalogStructure])

  return shouldShowJobCatalogColumns
}
